import { render, staticRenderFns } from "./projectAlternatives.vue?vue&type=template&id=121bb2a5&scoped=true"
import script from "./projectAlternatives.vue?vue&type=script&lang=js"
export * from "./projectAlternatives.vue?vue&type=script&lang=js"
import style0 from "./projectAlternatives.vue?vue&type=style&index=0&id=121bb2a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121bb2a5",
  null
  
)

export default component.exports